const answers = [
    {
        answer: "Yes",
        response: "I love you too",
        background: "clouds.svg",
        play: false
    },
    {
        answer: "No",
        response: "ok then 😿",
        background: "autumn.svg",
        play: false
    },
    {
        answer: "Forever",
        response: "...and ever ♥",
        background: "stars.svg",
        play: false
    },
    {
        answer: "Never",
        response:`Who can say where the road goes?
        Where the day flows?
        Only time.
        And who can say if your love grows
        As your heart chose?
        Only time.
        
        Who can say why your heart sighs
        As your love flies?
        Only time.
        And who can say why your heart cries
        When your love lies?
        Only time.
        
        Who can say when the roads meet
        That love might be in your heart?
        And who can say when the day sleeps
        If the night keeps all your heart,
        Night keeps all your heart?
        
        Who can say if your love grows
        As your heart chose?
        Only time.
        And who can say where the road goes?
        Where the day flows?
        Only time.
        
        Who knows? Only time.
        Who knows? Only time.
        `,
        background: 'rain.svg',
        play: true
    }
]

export default answers